import { connect } from 'react-redux';
import { FormattedMessage, FormattedDate } from 'react-intl';

import {
    getDrawdownNextRepaymentAmount,
    getDrawdownNextRepaymentDate
} from '../../../../../api/repaymentScheduleSelector';

import { MoneyWithDecimals } from '../../../../ui/moneyWithDecimals';
import SummaryRow from '../../../../ui/summaryRow/SummaryRow';

import messages from './NextRepayment.messages';
import { RootState } from '@iwProvider/configureStore';
import { H3 } from '@ui';

const mapStateToProps = (state: RootState) => ({
    nextRepaymentAmount: getDrawdownNextRepaymentAmount(state),
    nextRepaymentDate: getDrawdownNextRepaymentDate(state)
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const NextRepayment = ({
    nextRepaymentAmount,
    nextRepaymentDate
}: PropsFromRedux) => {
    return (
        <div>
            <H3 className="mb-m text-m font-normal lg:mb-xl">
                <FormattedMessage {...messages.firstRepayment} />
            </H3>

            <SummaryRow className="mb-m lg:mb-xl">
                <MoneyWithDecimals
                    className="text-2xl lg:text-5xl"
                    value={nextRepaymentAmount}
                    decimalWithSeparatorClassName="lg:text-xl"
                />
                <FormattedDate
                    value={new Date(nextRepaymentDate)}
                    day="numeric"
                    month="long"
                    year="numeric"
                />
            </SummaryRow>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(NextRepayment);
